import React, { useContext } from 'react';
import { NavLink, useHistory } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faUser, faFileAlt, faPalette, faSignOutAlt, faList, faEnvelope, faInfoCircle, faQrcode } from '@fortawesome/free-solid-svg-icons';

import { AuthContext } from '../../context/auth-context';
import { useStoreDetailsContext } from '../../context/store-details-context';
import useTranslation from '../../Hooks/translation-hook';

import './NavLinks.css';

const NavLinks = props => {
  const history = useHistory();
  const { t } = useTranslation();

  const auth = useContext(AuthContext);
  const { storeUN } = useStoreDetailsContext();

  const handleNavigate = () => {
    if (props.onNavigate) {
      props.onNavigate();
    }
  };

  const NavigateToLogin = () => {
    history.push(`/login`);
    handleNavigate();
  };

  const handleLogout = () => {
    auth.logout();
    handleNavigate();
  };

  return <ul className={`nav-links ${props.classes ? props.classes : 'default'}`}>
    {auth.role === 'viewer' &&
      <>
        <li>
          <FontAwesomeIcon className="store-icon" icon={faEye} />
          <NavLink to={`/store/${storeUN}`} onClick={handleNavigate}>{t('nav.store')}</NavLink>
        </li>
        <li>
          <FontAwesomeIcon className="contact-icon" icon={faEnvelope} />
          <NavLink to={`/store/contact/${storeUN}`} onClick={handleNavigate}>{t('nav.contact')}</NavLink>
        </li>
        <li>
          <FontAwesomeIcon className="about-icon" icon={faInfoCircle} />
          <NavLink to={`/store/about/${storeUN}`} onClick={handleNavigate}>{t('nav.about')}</NavLink>
        </li>
        <li>
          <button className='login-btn' onClick={NavigateToLogin}>{t('nav.login')}</button>
        </li>
      </>

    }
    {auth.role === 'admin' &&
      <li>
        <FontAwesomeIcon className="stores-icon" icon={faList} />
        <NavLink to="/administration/home" onClick={handleNavigate}>{t('nav.stores')}</NavLink>
      </li>
    }
    {auth.role === 'store' &&
      <>
        <li>
          <FontAwesomeIcon className="store-icon" icon={faEye} />
          <NavLink to={`/store/${auth.username}`} onClick={handleNavigate}>{t('nav.store')}</NavLink>
        </li>
        <li>
          <FontAwesomeIcon className="about-icon" icon={faInfoCircle} />
          <NavLink to={`/store/about/${auth.username}`} onClick={handleNavigate}>{t('nav.about')}</NavLink>
        </li>
        <li>
          <FontAwesomeIcon className="contact-icon" icon={faEnvelope} />
          <NavLink to={`/store/contact/${auth.username}`} onClick={handleNavigate}>{t('nav.contact')}</NavLink>
        </li>
        <li>
          <FontAwesomeIcon className="profile-icon" icon={faUser} />
          <NavLink to="/store/profile/edit" onClick={handleNavigate}>{t('nav.profile')}</NavLink>
        </li>
        <li>
          <FontAwesomeIcon className="details-icon" icon={faFileAlt} />
          <NavLink to="/store/details/edit" onClick={handleNavigate}>{t('nav.details')}</NavLink>
        </li>
        <li>
          <FontAwesomeIcon className="theme-icon" icon={faPalette} />
          <NavLink to="/store/theme/edit" onClick={handleNavigate}>{t('nav.theme')}</NavLink>
        </li>
        <li>
          <FontAwesomeIcon className="qr-icon" icon={faQrcode} />
          <NavLink to={`/store/qr/${auth.username}`} onClick={handleNavigate}>{t('nav.qrBuilder')}</NavLink>
        </li>
      </>
    }
    {(auth.role === 'admin' || auth.role === 'store') && props.showLogout &&
      <li>
        <FontAwesomeIcon className="logout-icon" icon={faSignOutAlt} />
        <button className='logout-btn' onClick={handleLogout}>{t('nav.logout')}</button>
      </li>
    }
  </ul>
};

export default NavLinks;